export default class ValidationState {
  constructor(
    public isValid: boolean,
    public invalidReason: string
  ) { }
}